import { EmphasizedText } from '@civilgrid/ui/components';
import { CONFIDENTIALITY_NOTICE } from '~/constants/disclaimer';

interface ConfidentialityNoticeProps {
  /** Sentence opener for this surface; must end in "represents". */
  leadIn: string;
  'data-testid'?: string;
}

/** The single rendering of the confidentiality notice, so the three surfaces showing it cannot drift apart. */
export function ConfidentialityNotice({
  leadIn,
  'data-testid': testId = 'confidentiality-notice',
}: ConfidentialityNoticeProps) {
  return (
    <span data-testid={testId}>
      {leadIn} <EmphasizedText segments={CONFIDENTIALITY_NOTICE} />
    </span>
  );
}
